import React, { useState, useEffect } from "react";

const texts = [
  "I am a problem solver",
  "I am a football lover",
  "I am a sunrise enthusiast",
];

const Typewriter = () => {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(120);

  useEffect(() => {
    const handleTyping = () => {
      const i = loopNum % texts.length;
      const fullText = texts[i];

      if (isDeleting) {
        if (text.length > 6) {
          setText(fullText.substring(0, text.length - 1));
        } else {
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
        }
      } else {
        setText(fullText.substring(0, text.length + 1));
      }

      setTypingSpeed(isDeleting ? 30 : 120);

      if (!isDeleting && text === fullText) {
        setTimeout(() => setIsDeleting(true), 500);
      }
    };

    const typingTimer = setTimeout(handleTyping, typingSpeed);

    return () => clearTimeout(typingTimer);
  }, [text, isDeleting, loopNum, typingSpeed]);

  return (
    <div className="text-[20px] md:text-[30px] 2xl:text-[30px] flex font-normal">
      <span>{text || " "}</span>
    </div>
  );
};

export default Typewriter;
